import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { defaultTransporterData, getTransporterById, updateTransporter, createTransporter } from '@/api/transporters';
import { AppModule } from '@/store/modules/app';
import { TagsViewModule } from '@/store/modules/tags-view';
import router from '@/router';
import { Action } from 'vuex-module-decorators';
import { getQuery } from '@/utils';
import { getCities, getCityById, createCity } from '@/api/locations/cities';
import { getStates } from '@/api/locations/states';
import Pagination from '@/components/Pagination/index.vue';
import { getBranchById, getBranches } from '@/api/locations/branches';
import { getPincodes } from '@/api/pincode';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.formData = Object.assign({}, defaultTransporterData);
    this.popOverData = Object.assign({});
    this.loading = false;
    this.listLoading = true;
    this.list = [];
    this.branchList = [];
    this.cityList = [];
    this.countryId = 0;
    this.total = 0;
    this.tableKey = 0;
    this.pincodeList = [];
    this.stateList = [];
    this.stateListLoading = false;
    this.bookingStateList = [];
    this.bookingCityList = [];
    this.listQuery = {
      page: 1,
      limit: 40,
      code: undefined,
      name: undefined,
      enabled: true,
      countryId: 0,
      sort: 'name,ASC',
      filter: {
        code: '$contL',
        name: '$contL',
        enabled: '$eq',
        countryId: '$eq'
      }
    };
    this.sortOptions = [{
      label: 'ID Ascending',
      key: 'id,ASC'
    }, {
      label: 'ID Descending',
      key: 'id,DESC'
    }];
    this.rules = {
      name: [{
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      }, {
        min: 3,
        max: 150,
        message: 'Length should be 3 to 150',
        trigger: 'blur'
      }],
      // gstNumber: [
      //   {
      //     pattern: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
      //     message: "Enter a valid GST number",
      //     trigger: "blur",
      //   },
      // ],
      addressCityId: {
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      },
      branchId: {
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      }
    };
  }
  data() {
    return {
      dialogTableVisible: false,
      dialogFormVisible: false
    };
  }
  get lang() {
    return AppModule.language;
  }
  created() {
    // this.countryId = parseInt(
    //   this.$route.params && this.$route.params.countryId
    // )
    this.countryId = 1;
    this.getList();
  }
  async activated() {
    // Load state lists and branches first
    await this.fetchBranches();
    await this.getStateList();
    await this.getBookingStateList();
    if (this.isEdit) {
      const id = this.$route.params && this.$route.params.id;
      await this.fetchData(parseInt(id));
    } else {
      this.formData = Object.assign({}, defaultTransporterData);
    }
    this.tempTagView = Object.assign({}, this.$route);
  }
  async getList() {
    try {
      this.listLoading = true;
      this.listQuery.countryId = this.countryId;
      const data = await getStates(getQuery(this.listQuery));
      this.list = data.data;
      this.total = data.total;
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  async getStateList() {
    try {
      this.stateListLoading = true;
      this.listQuery.countryId = 1;
      const data = await getStates(getQuery(this.listQuery));
      this.stateList = data.data;
      this.stateListLoading = false;
    } catch (error) {
      this.stateListLoading = false;
    }
  }
  async getBookingStateList() {
    try {
      this.stateListLoading = true;
      this.listQuery.countryId = 1;
      const data = await getStates(getQuery(this.listQuery));
      this.bookingStateList = data.data;
      this.stateListLoading = false;
    } catch (error) {
      this.stateListLoading = false;
    }
  }
  async getPincodeList(query) {
    try {
      if (query && query.length > 2) {
        this.pincodeList = await getPincodes(getQuery({
          pincode: query,
          filter: {
            pincode: '$starts'
          }
        }));
      }
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async fetchBranches() {
    this.branchList = await getBranches(getQuery({
      enabled: true,
      sort: 'name,ASC',
      filter: {
        enabled: 'eq'
      }
    }));
  }
  async fetchData(id) {
    try {
      const data = await getTransporterById(id);
      this.formData = data;
      // Fetch cities for the selected state
      if (data.stateId) {
        await this.getCityList();
      }
      // Fetch cities for the selected booking state
      if (data.bookingStateId) {
        await this.getBookingCityList();
      }
      // Set tagsview title
      const title = this.formData.name;
      this.setTagsViewTitle(title);
      this.setPageTitle(title);
    } catch (err) {
      // Handle error appropriately
    }
  }
  async getCityList() {
    try {
      this.cityList = await getCities(getQuery({
        stateId: this.formData.stateId,
        filter: {
          stateId: '$eq'
        }
      }));
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async getBookingCityList() {
    try {
      this.bookingCityList = await getCities(getQuery({
        stateId: this.formData.bookingStateId,
        filter: {
          stateId: '$eq'
        }
      }));
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async getCityById(cityId) {
    try {
      if (cityId) {
        const data = await getCityById(cityId);
        this.cityList = [data];
      }
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  async updateLocation(cityId) {
    if (cityId) {
      const city = await getCityById(cityId);
      this.formData.city = {
        id: city.id
      };
      this.formData.country = {
        id: city.countryId
      };
    }
  }
  async updateBranch(branchId) {
    if (branchId) {
      const branch = await getBranchById(branchId);
      this.formData.branch = {
        id: branch.id
      };
    }
  }
  setTagsViewTitle(title) {
    const tagView = this.tempTagView;
    if (tagView) {
      tagView.title = `${title}-${this.formData.id}`;
      TagsViewModule.updateVisitedView(tagView);
    }
  }
  setPageTitle(title) {
    document.title = `${title} - ${this.formData.id}`;
  }
  submitPopOver() {
    if (!this.popOverData.name && !this.popOverData.stateId) {
      this.$message({
        message: 'Either State or City name is required',
        type: 'warning'
      });
      return false;
    }
    this.savePopOver();
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        // either gst or vehicle number must be filled
        if (!this.formData.gstNumber && !this.formData.vehicleNumber) {
          this.$message({
            message: 'Either GST or vehicle number is required',
            type: 'warning'
          });
          return false;
        }
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  async handleTableLoad() {
    try {
      if (this.shouldLoadMoreData()) {
        this.listLoading = true;
        this.listQuery.page++;
        const data = await getStates(getQuery(this.listQuery));
        this.list = [...this.list, ...data.data];
        this.total = data.total;
        this.listLoading = false;
      }
    } catch (error) {
      this.listLoading = false;
    }
  }
  shouldLoadMoreData() {
    const tableBody = document.querySelector('.el-table__body-wrapper');
    const tableBottom = tableBody.scrollHeight - tableBody.clientHeight;
    const scrollPosition = tableBody.scrollTop;
    return scrollPosition > tableBottom * 0.9;
  }
  resetForm() {
    this.$refs.formData.resetFields();
  }
  async savePopOver() {
    try {
      this.loading = true;
      this.popOverData.countryId = 1;
      await createCity(this.popOverData);
      this.loading = false;
      this.$notify({
        title: 'Success',
        message: 'City saved',
        type: 'success',
        duration: 2000
      });
    } catch (error) {
      this.loading = false;
    }
  }
  async saveForm() {
    try {
      this.loading = true;
      await this.updateBranch(this.formData.branchId);
      if (this.isEdit) {
        await updateTransporter(this.formData.id, this.formData);
      } else {
        await createTransporter(this.formData);
      }
      this.loading = false;
      this.$notify({
        title: 'Success',
        message: 'Transporter saved',
        type: 'success',
        duration: 2000
      });
      router.push('/transporters/list');
    } catch (err) {
      this.loading = false;
    }
  }
};
__decorate([Prop({
  default: false
})], default_1.prototype, "isEdit", void 0);
__decorate([Action], default_1.prototype, "savePopOver", null);
__decorate([Action], default_1.prototype, "saveForm", null);
default_1 = __decorate([Component({
  name: 'TransporterDetail',
  components: {
    Pagination
  }
})], default_1);
export default default_1;